import http from "../http-common";
import authHeader from "./authHeader";
import { DEPARTMENT_API } from "../api";
const getAllDepartments = () => {
  return http.get(`${DEPARTMENT_API}`);
};

const createDepartment = (data) => {
  return http.post(`${DEPARTMENT_API}`, data, { headers: authHeader() });
};

const DepartmentService = {
  getAllDepartments,

  createDepartment,
};

export default DepartmentService;
